export const SENTRY_RELEASE: string | undefined = 'a121a2aa2e4d3efca65bafa3624f10421bbf7781';
